import { useCallback, useState } from "react";
import { toggleListOption } from "../common/helpers/listOptions";
import { ListOption } from "../common/types";

/**
 * Selected units + units error for create/edit forms that pick authorised units.
 * Callers own reset/sync (e.g. clearing on role change or restoring from query).
 */
export const useSelectedUnits = (initial: ListOption[] = []) => {
    const [selectedUnits, setSelectedUnits] = useState<ListOption[]>(initial);
    const [unitsError, setUnitsError] = useState<string>();

    const updateUnitList = useCallback((selectedUnit: ListOption) => {
        setUnitsError(undefined);
        setSelectedUnits((current) => toggleListOption(current, selectedUnit));
    }, []);

    return {
        selectedUnits,
        setSelectedUnits,
        unitsError,
        setUnitsError,
        updateUnitList,
    };
};
